export default __webpack_public_path__ + "static/media/line-md_email.1bc760a9.svg";